import { useCallback, useMemo, useState, useSyncExternalStore, useRef } from "react";

const Get = (props) => {
  const [load, setLoad] = useState(false);
  const post = useRef();
  
  const getServerSnapshot = () => {
    return [];
  }
  
  const url = {
    base: `${tmp_path.site_url}/wp-json/wp/v2/${props.postType}?per_page=${props.perPage}&page=${props.page}&_embed`,
    post: `${tmp_path.site_url}/wp-json/wp/v2/${props.postType}/${props.id}?_embed`
  }
  
  const urlState = props.type ? props.type : 'base';

  const subscribe = useCallback((callback) => {
    fetch(
      url[urlState])
      .then((response) => response.json())
      .then((data) => {
        post.current = data;
        callback();
      });
  }, [post]);

  return useSyncExternalStore(
    subscribe, // ストアが変更されるたびに呼び出されるコールバックを登録するための関数
    () => post.current, // ストアの現在の値を返す関数
    getServerSnapshot // サーバーレンダリング時にスナップショットを返すための関数
  );
};
export default Get;
